import { ProviderFinder } from "#/pages/provider-finder"
import React from "react"
import { ProviderFinderErrorReportingProvider } from "#/pages/provider-finder/context/ErrorReportingContext"
import { UserContextProvider } from "#/pages/provider-finder/context/UserContext"
// should decouple the following imports in the long run
import { useAuthentication } from "../../../context/authentication/AuthenticationProvider"
import { CompanyContextProvider } from "#/pages/provider-finder/context/CompanyContextProvider"
import { CarrotMatchContextProvider } from "#/components/carrot-match-fertility-clinic-precision-matching/context/CarrotMatchContext"
import useGetMemberCountry from "#/components/company/hooks/useGetMemberCountry"
import useGetMemberCompany from "#/components/company/hooks/useGetMemberCompany"

export const ProviderFinderAdapter = (): JSX.Element => {
  const memberCountry = useGetMemberCountry()
  const memberCompany = useGetMemberCompany()
  const countryCode = memberCountry?.data?.countryCode
  const companyId = memberCompany?.data?.companyId

  const { isLoggedIn, handleSessionExpiration } = useAuthentication()

  return (
    <ProviderFinderErrorReportingProvider>
      <UserContextProvider
        companyCountryCode={countryCode}
        isLoggedIn={isLoggedIn}
        handleSessionExpiration={handleSessionExpiration}
      >
        <CompanyContextProvider companyId={companyId}>
          <CarrotMatchContextProvider>
            <ProviderFinder />
          </CarrotMatchContextProvider>
        </CompanyContextProvider>
      </UserContextProvider>
    </ProviderFinderErrorReportingProvider>
  )
}
